import { render, staticRenderFns } from "./EntoDataSummary.vue?vue&type=template&id=12bb282a&"
import script from "./EntoDataSummary.vue?vue&type=script&lang=js&"
export * from "./EntoDataSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports